import React from 'react';
import PropTypes from 'prop-types';
import './styles/index.scss';
import { version } from '../saagie-ui/package.json';

const Wrapper = ({ children }) => (
  <div id="doc-container">
    <a id="version-number" href="/versions.html" style={{ display: 'none' }}>
      Version
      {' '}
      { version }
    </a>
    {children}
  </div>
);

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Wrapper;
